<template>
  <div :style="`-webkit-transform:translate(${value.x}px,${value.y}px);transform:translate(${value.x}px, ${value.y}px);`" :data-x="value.x" :data-y="value.y" >
    <md-icon :data-key="number" v-if="value.type === 'hydraulic'" class="md-size-05x">opacity</md-icon>
    <md-icon :data-key="number" v-if="value.type === 'eletric'" class="md-size-05x">power</md-icon>
    <md-icon :data-key="number" v-if="value.type === 'equipment'" class="  md-size-05x">kitchen</md-icon>
  </div>
</template>
<script>
export default {
  name: 'draggableStructure',
  props: ['value', 'number']
}
</script>
<style scoped>
.md-size-05x {
  width: 30x;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// DraggableStructure.vue?62e6778d